import React from "react";
import ReactLoading from "react-loading";

function Loading(props) {
  return (
    <>
      <ReactLoading {...props} />
    </>
  );
}

export default Loading;
